export default [
  {
    id: 267993365,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjc5OTMzNjU=",
    name: "AI-Chat-Bot",
    full_name: "mdial009/AI-Chat-Bot",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/AI-Chat-Bot",
    description: 'a "Smart" Chat Bot Program',
    fork: false,
    url: "https://api.github.com/repos/mdial009/AI-Chat-Bot",
    forks_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/forks",
    keys_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/teams",
    hooks_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/AI-Chat-Bot/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/AI-Chat-Bot/deployments",
    created_at: "2020-05-30T02:16:59Z",
    updated_at: "2020-06-25T14:54:48Z",
    pushed_at: "2020-06-25T14:54:46Z",
    git_url: "git://github.com/mdial009/AI-Chat-Bot.git",
    ssh_url: "git@github.com:mdial009/AI-Chat-Bot.git",
    clone_url: "https://github.com/mdial009/AI-Chat-Bot.git",
    svn_url: "https://github.com/mdial009/AI-Chat-Bot",
    homepage: "",
    size: 5,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 267186426,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjcxODY0MjY=",
    name: "AudioProject",
    full_name: "mdial009/AudioProject",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/AudioProject",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/mdial009/AudioProject",
    forks_url: "https://api.github.com/repos/mdial009/AudioProject/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/AudioProject/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/AudioProject/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/AudioProject/teams",
    hooks_url: "https://api.github.com/repos/mdial009/AudioProject/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/AudioProject/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/AudioProject/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/AudioProject/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/AudioProject/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/AudioProject/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/AudioProject/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/AudioProject/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/AudioProject/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/AudioProject/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/AudioProject/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/AudioProject/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/AudioProject/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/AudioProject/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/AudioProject/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/AudioProject/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/AudioProject/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/AudioProject/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/AudioProject/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/AudioProject/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/AudioProject/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/AudioProject/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/AudioProject/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/AudioProject/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/AudioProject/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/AudioProject/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/AudioProject/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/AudioProject/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/AudioProject/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/AudioProject/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/AudioProject/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/AudioProject/deployments",
    created_at: "2020-05-27T01:00:49Z",
    updated_at: "2020-07-19T22:52:56Z",
    pushed_at: "2020-07-19T22:52:50Z",
    git_url: "git://github.com/mdial009/AudioProject.git",
    ssh_url: "git@github.com:mdial009/AudioProject.git",
    clone_url: "https://github.com/mdial009/AudioProject.git",
    svn_url: "https://github.com/mdial009/AudioProject",
    homepage: null,
    size: 1310,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 220345366,
    node_id: "MDEwOlJlcG9zaXRvcnkyMjAzNDUzNjY=",
    name: "burghy-bites",
    full_name: "mdial009/burghy-bites",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/burghy-bites",
    description:
      "A web and mobile application for rating and reviewing food at SUNY Plattsburgh.",
    fork: true,
    url: "https://api.github.com/repos/mdial009/burghy-bites",
    forks_url: "https://api.github.com/repos/mdial009/burghy-bites/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/burghy-bites/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/burghy-bites/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/burghy-bites/teams",
    hooks_url: "https://api.github.com/repos/mdial009/burghy-bites/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/burghy-bites/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/burghy-bites/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/burghy-bites/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/burghy-bites/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/burghy-bites/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/burghy-bites/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/burghy-bites/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/burghy-bites/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/burghy-bites/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/burghy-bites/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/burghy-bites/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/burghy-bites/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/burghy-bites/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/burghy-bites/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/burghy-bites/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/burghy-bites/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/burghy-bites/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/burghy-bites/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/burghy-bites/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/burghy-bites/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/burghy-bites/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/burghy-bites/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/burghy-bites/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/burghy-bites/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/burghy-bites/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/burghy-bites/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/burghy-bites/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/burghy-bites/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/burghy-bites/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/burghy-bites/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/burghy-bites/deployments",
    created_at: "2019-11-07T23:11:17Z",
    updated_at: "2019-11-21T20:46:24Z",
    pushed_at: "2019-11-21T20:46:22Z",
    git_url: "git://github.com/mdial009/burghy-bites.git",
    ssh_url: "git@github.com:mdial009/burghy-bites.git",
    clone_url: "https://github.com/mdial009/burghy-bites.git",
    svn_url: "https://github.com/mdial009/burghy-bites",
    homepage: null,
    size: 1150,
    stargazers_count: 0,
    watchers_count: 0,
    language: "TypeScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 243649485,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDM2NDk0ODU=",
    name: "club-hub-legit-fe",
    full_name: "mdial009/club-hub-legit-fe",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/club-hub-legit-fe",
    description: "Frontend Repo for Club Hub Legit",
    fork: true,
    url: "https://api.github.com/repos/mdial009/club-hub-legit-fe",
    forks_url: "https://api.github.com/repos/mdial009/club-hub-legit-fe/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/club-hub-legit-fe/teams",
    hooks_url: "https://api.github.com/repos/mdial009/club-hub-legit-fe/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/club-hub-legit-fe/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/club-hub-legit-fe/deployments",
    created_at: "2020-02-28T01:00:45Z",
    updated_at: "2020-03-12T23:22:19Z",
    pushed_at: "2020-03-12T23:22:15Z",
    git_url: "git://github.com/mdial009/club-hub-legit-fe.git",
    ssh_url: "git@github.com:mdial009/club-hub-legit-fe.git",
    clone_url: "https://github.com/mdial009/club-hub-legit-fe.git",
    svn_url: "https://github.com/mdial009/club-hub-legit-fe",
    homepage: null,
    size: 264,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 230809232,
    node_id: "MDEwOlJlcG9zaXRvcnkyMzA4MDkyMzI=",
    name: "countCharacters",
    full_name: "mdial009/countCharacters",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/countCharacters",
    description: "count the characters from a string and print them out",
    fork: false,
    url: "https://api.github.com/repos/mdial009/countCharacters",
    forks_url: "https://api.github.com/repos/mdial009/countCharacters/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/countCharacters/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/countCharacters/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/countCharacters/teams",
    hooks_url: "https://api.github.com/repos/mdial009/countCharacters/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/countCharacters/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/countCharacters/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/countCharacters/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/countCharacters/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/countCharacters/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/countCharacters/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/countCharacters/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/countCharacters/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/countCharacters/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/countCharacters/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/countCharacters/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/countCharacters/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/countCharacters/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/countCharacters/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/countCharacters/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/countCharacters/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/countCharacters/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/countCharacters/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/countCharacters/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/countCharacters/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/countCharacters/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/countCharacters/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/countCharacters/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/countCharacters/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/countCharacters/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/countCharacters/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/countCharacters/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/countCharacters/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/countCharacters/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/countCharacters/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/countCharacters/deployments",
    created_at: "2019-12-29T22:12:54Z",
    updated_at: "2020-08-28T07:37:24Z",
    pushed_at: "2020-08-28T07:37:21Z",
    git_url: "git://github.com/mdial009/countCharacters.git",
    ssh_url: "git@github.com:mdial009/countCharacters.git",
    clone_url: "https://github.com/mdial009/countCharacters.git",
    svn_url: "https://github.com/mdial009/countCharacters",
    homepage: null,
    size: 0,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 230813147,
    node_id: "MDEwOlJlcG9zaXRvcnkyMzA4MTMxNDc=",
    name: "Evens",
    full_name: "mdial009/Evens",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/Evens",
    description:
      "write a function that returns the array with only even numbers",
    fork: false,
    url: "https://api.github.com/repos/mdial009/Evens",
    forks_url: "https://api.github.com/repos/mdial009/Evens/forks",
    keys_url: "https://api.github.com/repos/mdial009/Evens/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/Evens/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/Evens/teams",
    hooks_url: "https://api.github.com/repos/mdial009/Evens/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/Evens/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/Evens/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/Evens/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/Evens/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/Evens/tags",
    blobs_url: "https://api.github.com/repos/mdial009/Evens/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/mdial009/Evens/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/mdial009/Evens/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/mdial009/Evens/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/mdial009/Evens/statuses/{sha}",
    languages_url: "https://api.github.com/repos/mdial009/Evens/languages",
    stargazers_url: "https://api.github.com/repos/mdial009/Evens/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/Evens/contributors",
    subscribers_url: "https://api.github.com/repos/mdial009/Evens/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/Evens/subscription",
    commits_url: "https://api.github.com/repos/mdial009/Evens/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/Evens/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/Evens/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/Evens/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/Evens/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/Evens/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/Evens/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/Evens/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/mdial009/Evens/downloads",
    issues_url: "https://api.github.com/repos/mdial009/Evens/issues{/number}",
    pulls_url: "https://api.github.com/repos/mdial009/Evens/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/Evens/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/Evens/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/mdial009/Evens/labels{/name}",
    releases_url: "https://api.github.com/repos/mdial009/Evens/releases{/id}",
    deployments_url: "https://api.github.com/repos/mdial009/Evens/deployments",
    created_at: "2019-12-29T22:59:22Z",
    updated_at: "2019-12-29T23:14:23Z",
    pushed_at: "2019-12-29T23:14:21Z",
    git_url: "git://github.com/mdial009/Evens.git",
    ssh_url: "git@github.com:mdial009/Evens.git",
    clone_url: "https://github.com/mdial009/Evens.git",
    svn_url: "https://github.com/mdial009/Evens",
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 250140654,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTAxNDA2NTQ=",
    name: "firebase-unity",
    full_name: "mdial009/firebase-unity",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/firebase-unity",
    description:
      "Youtube link for first part of two part tutorial for setting up unity and firebase: https://www.youtube.com/watch?v=WjWHVye4kxo&t=7s",
    fork: true,
    url: "https://api.github.com/repos/mdial009/firebase-unity",
    forks_url: "https://api.github.com/repos/mdial009/firebase-unity/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/firebase-unity/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/firebase-unity/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/firebase-unity/teams",
    hooks_url: "https://api.github.com/repos/mdial009/firebase-unity/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/firebase-unity/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/firebase-unity/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/firebase-unity/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/firebase-unity/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/firebase-unity/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/firebase-unity/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/firebase-unity/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/firebase-unity/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/firebase-unity/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/firebase-unity/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/firebase-unity/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/firebase-unity/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/firebase-unity/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/firebase-unity/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/firebase-unity/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/firebase-unity/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/firebase-unity/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/firebase-unity/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/firebase-unity/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/firebase-unity/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/firebase-unity/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/firebase-unity/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/firebase-unity/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/firebase-unity/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/firebase-unity/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/firebase-unity/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/firebase-unity/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/firebase-unity/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/firebase-unity/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/firebase-unity/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/firebase-unity/deployments",
    created_at: "2020-03-26T02:22:15Z",
    updated_at: "2020-03-26T02:22:16Z",
    pushed_at: "2018-04-12T16:10:16Z",
    git_url: "git://github.com/mdial009/firebase-unity.git",
    ssh_url: "git@github.com:mdial009/firebase-unity.git",
    clone_url: "https://github.com/mdial009/firebase-unity.git",
    svn_url: "https://github.com/mdial009/firebase-unity",
    homepage: "",
    size: 53326,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 290960176,
    node_id: "MDEwOlJlcG9zaXRvcnkyOTA5NjAxNzY=",
    name: "Github-User-Project",
    full_name: "mdial009/Github-User-Project",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/Github-User-Project",
    description:
      "A React App that lets you search up different users on GitHub using GitHub API. You are able to see different stats about the users(Followers/following, repos)",
    fork: false,
    url: "https://api.github.com/repos/mdial009/Github-User-Project",
    forks_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/teams",
    hooks_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/Github-User-Project/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/Github-User-Project/deployments",
    created_at: "2020-08-28T05:36:32Z",
    updated_at: "2020-08-28T05:41:48Z",
    pushed_at: "2020-08-28T05:40:21Z",
    git_url: "git://github.com/mdial009/Github-User-Project.git",
    ssh_url: "git@github.com:mdial009/Github-User-Project.git",
    clone_url: "https://github.com/mdial009/Github-User-Project.git",
    svn_url: "https://github.com/mdial009/Github-User-Project",
    homepage: "",
    size: 268,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 268941278,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjg5NDEyNzg=",
    name: "ICM",
    full_name: "mdial009/ICM",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/ICM",
    description:
      "Used the TensorFlow library to train the AI and based on data and take that data to classify an image.",
    fork: false,
    url: "https://api.github.com/repos/mdial009/ICM",
    forks_url: "https://api.github.com/repos/mdial009/ICM/forks",
    keys_url: "https://api.github.com/repos/mdial009/ICM/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/ICM/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/ICM/teams",
    hooks_url: "https://api.github.com/repos/mdial009/ICM/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/ICM/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/ICM/events",
    assignees_url: "https://api.github.com/repos/mdial009/ICM/assignees{/user}",
    branches_url: "https://api.github.com/repos/mdial009/ICM/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/ICM/tags",
    blobs_url: "https://api.github.com/repos/mdial009/ICM/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/mdial009/ICM/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/mdial009/ICM/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/mdial009/ICM/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/mdial009/ICM/statuses/{sha}",
    languages_url: "https://api.github.com/repos/mdial009/ICM/languages",
    stargazers_url: "https://api.github.com/repos/mdial009/ICM/stargazers",
    contributors_url: "https://api.github.com/repos/mdial009/ICM/contributors",
    subscribers_url: "https://api.github.com/repos/mdial009/ICM/subscribers",
    subscription_url: "https://api.github.com/repos/mdial009/ICM/subscription",
    commits_url: "https://api.github.com/repos/mdial009/ICM/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/ICM/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/mdial009/ICM/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/ICM/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/mdial009/ICM/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/ICM/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/ICM/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/ICM/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/mdial009/ICM/downloads",
    issues_url: "https://api.github.com/repos/mdial009/ICM/issues{/number}",
    pulls_url: "https://api.github.com/repos/mdial009/ICM/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/ICM/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/ICM/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/mdial009/ICM/labels{/name}",
    releases_url: "https://api.github.com/repos/mdial009/ICM/releases{/id}",
    deployments_url: "https://api.github.com/repos/mdial009/ICM/deployments",
    created_at: "2020-06-03T00:53:59Z",
    updated_at: "2020-07-11T00:26:53Z",
    pushed_at: "2020-07-11T00:26:51Z",
    git_url: "git://github.com/mdial009/ICM.git",
    ssh_url: "git@github.com:mdial009/ICM.git",
    clone_url: "https://github.com/mdial009/ICM.git",
    svn_url: "https://github.com/mdial009/ICM",
    homepage: "",
    size: 202,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 282167655,
    node_id: "MDEwOlJlcG9zaXRvcnkyODIxNjc2NTU=",
    name: "Javascript",
    full_name: "mdial009/Javascript",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/Javascript",
    description: "Javascript Projects  ",
    fork: false,
    url: "https://api.github.com/repos/mdial009/Javascript",
    forks_url: "https://api.github.com/repos/mdial009/Javascript/forks",
    keys_url: "https://api.github.com/repos/mdial009/Javascript/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/Javascript/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/Javascript/teams",
    hooks_url: "https://api.github.com/repos/mdial009/Javascript/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/Javascript/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/Javascript/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/Javascript/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/Javascript/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/Javascript/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/Javascript/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/Javascript/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/Javascript/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/Javascript/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/Javascript/statuses/{sha}",
    languages_url: "https://api.github.com/repos/mdial009/Javascript/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/Javascript/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/Javascript/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/Javascript/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/Javascript/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/Javascript/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/Javascript/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/Javascript/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/Javascript/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/Javascript/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/Javascript/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/Javascript/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/Javascript/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/mdial009/Javascript/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/Javascript/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/Javascript/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/Javascript/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/Javascript/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/Javascript/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/Javascript/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/Javascript/deployments",
    created_at: "2020-07-24T08:38:10Z",
    updated_at: "2020-08-25T19:43:56Z",
    pushed_at: "2020-08-25T19:43:54Z",
    git_url: "git://github.com/mdial009/Javascript.git",
    ssh_url: "git@github.com:mdial009/Javascript.git",
    clone_url: "https://github.com/mdial009/Javascript.git",
    svn_url: "https://github.com/mdial009/Javascript",
    homepage: null,
    size: 10088,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 242283324,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDIyODMzMjQ=",
    name: "L3v3l3ditor",
    full_name: "mdial009/L3v3l3ditor",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/L3v3l3ditor",
    description: "Level Editor using Unity 3D.",
    fork: false,
    url: "https://api.github.com/repos/mdial009/L3v3l3ditor",
    forks_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/forks",
    keys_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/teams",
    hooks_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/L3v3l3ditor/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/L3v3l3ditor/deployments",
    created_at: "2020-02-22T05:08:06Z",
    updated_at: "2020-07-11T00:18:29Z",
    pushed_at: "2020-07-11T00:18:23Z",
    git_url: "git://github.com/mdial009/L3v3l3ditor.git",
    ssh_url: "git@github.com:mdial009/L3v3l3ditor.git",
    clone_url: "https://github.com/mdial009/L3v3l3ditor.git",
    svn_url: "https://github.com/mdial009/L3v3l3ditor",
    homepage: null,
    size: 175008,
    stargazers_count: 1,
    watchers_count: 1,
    language: "C#",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 277147298,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzcxNDcyOTg=",
    name: "mdial009.github.io",
    full_name: "mdial009/mdial009.github.io",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/mdial009.github.io",
    description: "Portfolio Website",
    fork: false,
    url: "https://api.github.com/repos/mdial009/mdial009.github.io",
    forks_url: "https://api.github.com/repos/mdial009/mdial009.github.io/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/mdial009.github.io/teams",
    hooks_url: "https://api.github.com/repos/mdial009/mdial009.github.io/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/mdial009.github.io/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/mdial009.github.io/deployments",
    created_at: "2020-07-04T16:33:24Z",
    updated_at: "2020-08-25T03:41:55Z",
    pushed_at: "2020-08-26T19:42:04Z",
    git_url: "git://github.com/mdial009/mdial009.github.io.git",
    ssh_url: "git@github.com:mdial009/mdial009.github.io.git",
    clone_url: "https://github.com/mdial009/mdial009.github.io.git",
    svn_url: "https://github.com/mdial009/mdial009.github.io",
    homepage: "",
    size: 16660,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 154231536,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTQyMzE1MzY=",
    name: "plattssec.github.io",
    full_name: "mdial009/plattssec.github.io",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/plattssec.github.io",
    description: null,
    fork: true,
    url: "https://api.github.com/repos/mdial009/plattssec.github.io",
    forks_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/teams",
    hooks_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/plattssec.github.io/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/plattssec.github.io/deployments",
    created_at: "2018-10-22T23:38:41Z",
    updated_at: "2018-10-22T23:38:43Z",
    pushed_at: "2018-10-22T21:09:11Z",
    git_url: "git://github.com/mdial009/plattssec.github.io.git",
    ssh_url: "git@github.com:mdial009/plattssec.github.io.git",
    clone_url: "https://github.com/mdial009/plattssec.github.io.git",
    svn_url: "https://github.com/mdial009/plattssec.github.io",
    homepage: null,
    size: 0,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 290572900,
    node_id: "MDEwOlJlcG9zaXRvcnkyOTA1NzI5MDA=",
    name: "Stock-Web-Application",
    full_name: "mdial009/Stock-Web-Application",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/Stock-Web-Application",
    description:
      "This is a stock market dashboard to show some charts and data on some stock",
    fork: false,
    url: "https://api.github.com/repos/mdial009/Stock-Web-Application",
    forks_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/teams",
    hooks_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/Stock-Web-Application/deployments",
    created_at: "2020-08-26T18:21:15Z",
    updated_at: "2020-08-26T19:26:15Z",
    pushed_at: "2020-08-26T19:26:13Z",
    git_url: "git://github.com/mdial009/Stock-Web-Application.git",
    ssh_url: "git@github.com:mdial009/Stock-Web-Application.git",
    clone_url: "https://github.com/mdial009/Stock-Web-Application.git",
    svn_url: "https://github.com/mdial009/Stock-Web-Application",
    homepage: null,
    size: 4437,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 267192475,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjcxOTI0NzU=",
    name: "VirtualAssistant",
    full_name: "mdial009/VirtualAssistant",
    private: false,
    owner: {
      login: "mdial009",
      id: 36002261,
      node_id: "MDQ6VXNlcjM2MDAyMjYx",
      avatar_url: "https://avatars2.githubusercontent.com/u/36002261?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mdial009",
      html_url: "https://github.com/mdial009",
      followers_url: "https://api.github.com/users/mdial009/followers",
      following_url:
        "https://api.github.com/users/mdial009/following{/other_user}",
      gists_url: "https://api.github.com/users/mdial009/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mdial009/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mdial009/subscriptions",
      organizations_url: "https://api.github.com/users/mdial009/orgs",
      repos_url: "https://api.github.com/users/mdial009/repos",
      events_url: "https://api.github.com/users/mdial009/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mdial009/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/mdial009/VirtualAssistant",
    description:
      "This is a Virtual Assistant program that gets the date, current time, Respond back with a random greeting, and return information on a person.",
    fork: false,
    url: "https://api.github.com/repos/mdial009/VirtualAssistant",
    forks_url: "https://api.github.com/repos/mdial009/VirtualAssistant/forks",
    keys_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/mdial009/VirtualAssistant/teams",
    hooks_url: "https://api.github.com/repos/mdial009/VirtualAssistant/hooks",
    issue_events_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/issues/events{/number}",
    events_url: "https://api.github.com/repos/mdial009/VirtualAssistant/events",
    assignees_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/branches{/branch}",
    tags_url: "https://api.github.com/repos/mdial009/VirtualAssistant/tags",
    blobs_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/languages",
    stargazers_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/stargazers",
    contributors_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/contributors",
    subscribers_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/subscribers",
    subscription_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/subscription",
    commits_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/mdial009/VirtualAssistant/merges",
    archive_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/downloads",
    issues_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/labels{/name}",
    releases_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/mdial009/VirtualAssistant/deployments",
    created_at: "2020-05-27T01:37:31Z",
    updated_at: "2020-06-13T17:17:18Z",
    pushed_at: "2020-05-30T20:56:36Z",
    git_url: "git://github.com/mdial009/VirtualAssistant.git",
    ssh_url: "git@github.com:mdial009/VirtualAssistant.git",
    clone_url: "https://github.com/mdial009/VirtualAssistant.git",
    svn_url: "https://github.com/mdial009/VirtualAssistant",
    homepage: "",
    size: 39907,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Python",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
];
